/*
Rajouté par Anas BOURAS
Objectif : empêcher le bouton "+" de dépasser le stock disponible
*/
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    const input = selector.querySelector('input');
    const plus = selector.querySelector('[name="plus"]');

    if (!input || !plus) return;

    plus.addEventListener('click', function (e) {
      const max = parseInt(input.getAttribute('max'));
      const current = parseInt(input.value);

      if (max && current >= max) {
        e.preventDefault();
        input.value = max;
      }
    });
  });
});